import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Col, Container, Row } from "reactstrap";
import pauseBtn from "../../../assets/images/bingo/pause-btn.png";
import playBtn from "../../../assets/images/bingo/play-btn.png";

const GetReady = ({ gamePaused, countdown, toggleGamePaused, onTimesUp, paramsReducerr }) => {
  const [allPlayers, setAllPlayers] = useState(false);

  const parameters = _.get(paramsReducerr, "2_preplay");

  // useEffect(() => {
  //   if (countdown > 0) {
  //     setTimeout(() => set_countdown(countdown - 1), 1000);
  //   } else {
  //     onTimesUp();
  //   }
  // }, [countdown]);

  const redCircle = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
    32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
    61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75,
  ];
  return (
    <div className="bingo-preplay-get-ready">
      <Container>
        <Row>
          <Col xs={12} sm={12} lg={12} xl={12}>
            <div className="bingo-preplay-content">
              <div className="bingo-preplay-numbers-container">
                <div className="bingo-logo">
                  <p className="red">B</p>
                  <p className="blue">I</p>
                  <p className="purple">N</p>
                  <p className="orange">G</p>
                  <p className="green">O</p>
                </div>
                <div className="bingo-preplay-numbers">
                  <div className="bingo-preplay-number">
                    {redCircle.map((number) => {
                      return <span className="red-filled-number-circle">{number}</span>;
                    })}
                  </div>
                  <div className="get-ready">
                    {gamePaused ? <h1>{parameters?.paused}</h1> : <h1>{parameters?.get_ready}</h1>}
                  </div>
                </div>
              </div>
              <div className="game-begins">
                <h4>{parameters?.game_begins}</h4>
                <h1>{countdown}</h1>
                <button onClick={toggleGamePaused} className="pause-btn">
                  {gamePaused ? <img src={playBtn} alt="" /> : <img className="pause-btn-get-ready" src={pauseBtn} alt="" />}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GetReady;
